import React, { useState } from "react";
import Switch from "react-switch";
import "./Toggle.scss";
import Yes from "../../assets/Toggle/Yes.svg";
import No from "../../assets/Toggle/No.svg";
import { ToggleProps } from "./Toggle.types";

export const Toggle: React.FC<ToggleProps> = ({ selected }) => {
  const [isChecked, toggleChecked] = useState<boolean>(selected);

  const handleToggle = () => {
    toggleChecked(!isChecked);
  };

  return (
    <label>
      <Switch
        id="react-toggle"
        onChange={handleToggle}
        checked={isChecked}
        offColor="#FFFFFF"
        onColor="#E7F4FC"
        width={59}
        height={26}
        handleDiameter={20}
        uncheckedIcon={
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              paddingTop: "3px",

              fontFamily: "Open Sans",
              fontStyle: "normal",
              fontWeight: "600" as any,
              fontSize: "14px",
              lineHeight: "18px",
              letterSpacing: "0.2px",
              color: "#737B7D",
            }}
          >
            no
          </div>
        }
        checkedIcon={
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              paddingTop: "3px",

              fontFamily: "Open Sans",
              fontStyle: "normal",
              fontWeight: "600" as any,
              fontSize: "14px",
              lineHeight: "18px",
              letterSpacing: "0.2px",
              color: "#737B7D",
            }}
          >
            yes
          </div>
        }
        checkedHandleIcon={
          <div style={{ paddingTop: "1px" }}>
            <img src={Yes} />
          </div>
        }
        uncheckedHandleIcon={
          <div style={{ paddingTop: "1px" }}>
            <img src={No} />
          </div>
        }
      />
    </label>
  );
};
